module.exports = "<header kd-dialog-header\r\n    ng-transclude=\"header\"></header>\r\n<section kd-dialog-content\r\n    ng-transclude></section>\r\n<footer kd-dialog-footer\r\n    ng-transclude=\"footer\"></footer>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-dialog/template.html
// module id = 301
// module chunks = 0